/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/quoteFileRejection.ts
 * FILE_ID: JOBHUB-QA-QUOTE-REJECT-001
 * PURPOSE: Name .ods and .docx before upload. The accept list stays.
 */
export function quoteFileRejection(name: string): string | null {
  const lower = name.toLowerCase()
  if (lower.endsWith('.ods') || lower.endsWith('.docx')) {
    return `${name}: use Excel, PDF, CSV or text.`
  }
  return null
}
